<template>
  <div class="content-wrapper calendar-position-modified">

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb :page-title="$t('all_tickets')" :directory="[$t('deals'), $t('all_deals'), currentPipeline]"
          :icon="'clipboard'" />
      </div>




      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">


          <button type="button" v-if="$can('create_deals')" class="btn btn-primary btn-with-shadow" data-toggle="modal"
            @click="openModalSuv(souvenirPipeline.id)">
            {{ $t("add_suvenir") }}
          </button>
        </div>
      </div>


      <div v-for="(pipeline, index) in visiblePipelineTicketTypeList"  :key="index" class="col-xl-3 mb-primary">
        <div class="card card-with-shadow border-0">

          <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">{{ pipeline.name }}</h4>
          </div>

          <div class="card-body">
            <button type="button" v-if="$can('create_deals')" class="btn btn-primary btn-with-shadow"
              data-toggle="modal" @click="openModalSet(pipeline.ticket_type)">
              {{ $t("add_visit") }}
            </button>
          </div>
        </div>
      </div>


    </div>



    <app-warehouse-item-modal-shop v-if="isWarehouseModalActive" :table-id="tableId" :pipeline-id="selectedPipeline"
      :selected-url="''" @close-modal="closeModal" />

    <app-table :id="tableId" @getFilteredValues="filteredValues" :options="options" @action="getAction" />

    <app-cash-modal v-if="isDealModalActive" :table-id="tableId" :selected-url="selectedUrl" :more-title="MoreTitle"
      :pipeline-id="selectedPipeline" :pipeline-type="selectedPipelineType" :pipeline-name="selectedPipelineName"
      @close-modal="closeModal" />

    <app-confirmation-modal v-if="confirmationModalActive" modal-id="deal-delete-modal" @confirmed="confirmed"
      @cancelled="cancelled" />

    <app-lost-reason-modal v-if="isModalActive" :table-id="tableId" :selected-url="selectedUrlReason"
      @close-modal="closeLostReasonModal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { dealStatus, tag, owner, pay, contactType } from "@app/Mixins/Global/FilterMixins";
import { formatDateToLocal, formatDateTimeToLocal, numberWithCurrencySymbol, numberWithCurrencyMuseum, urlGenerator } from "@app/Helpers/helpers";
import { getCustomFileds } from "@app/Mixins/Global/CustomFieldMixin";

export default {
  name: "ListView",
  extends: CoreLibrary,
  mixins: [dealStatus, tag, owner, pay, contactType, getCustomFileds],
  data() {
    return {
      formatDateToLocal,
      urlGenerator,
      isDealModalActive: false,
      isWarehouseModalActive: false,
      tableId: "deal-modal",
      confirmationModalActive: false,
      isModalActive: false,
      selectedUrlReason: "",
      deal: "",
      value: 0,
      selectedUrl: "",
      currentPipeline: "",
      localPipelineId: "",
      selectedPipeline: "",
      selectedPipelineType: "",
      pipelineValue: "",
      pipelineInitValue: 1,
      isPipelineEmpty: false,
      commonColumn: [
        {
          title: this.$t("id"),
          type: "text",
          key: "id",
        },
        {
          title: this.$t("title"),
          type: "link",
          key: "title",
          sortAble: true,
          isVisible: true,
          modifier: (value, row) => {
            return `crm/deal/${row.id}/details`;
          },
        },



        {
          title: this.$t("deal_value"),
          type: "custom-html",
          key: "value",
          modifier: (value) => {
            return `<p class="mb-0 d-flex align-items-center text-nowrap">${numberWithCurrencyMuseum(
              value
            )}</p>`;
          },
        },


        {
          title: this.$t("pay_type"),
          type: "custom-html",
          key: "pay_id",
          modifier: (value, row) => {
            if (value == 1) {
              return this.$t("pay_nal");
            } else if (value == 2) {
              return this.$t("pay_cardi");
            } else if (value == 3) {
              return this.$t("pay_online");
            }
          },
        },

        {
          title: this.$t("created_at"),
          type: "custom-html",
          key: "created_at",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${formatDateTimeToLocal(row.created_at)}</span>`
              : "-";
          },
        },


        {
          title: this.$t("owner"),
          type: "custom-html",
          key: "owner",
          modifier: (value, row) => {
            return value
              ? value.full_name
              : `<p class="font-size-80 text-secondary">` +
              this.$t("deal_has_no_owner") +
              `</p>`;
          },
        },
        {
          title: this.$t("tags"),
          type: "component",
          key: "tags",
          isVisible: true,
          componentName: "tags-type-column",
        },
        {
          title: this.$t("Action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
      options: {
        name: this.$t("deal_table"),
        url: "crm/deals",
        showHeader: true,
        columns: [],
        countView: true,
        filters: [
          {
            title: this.$t("owner"),
            type: "checkbox",
            key: "owner_is",
            option: [],
          },
          {
            title: this.$t("pay_type"),
            type: "checkbox",
            key: "pay_is",
            option: [],
          },

          {
            title: this.$t("created_date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },

          {
            title: this.$t("tag"),
            type: "multi-select-filter",
            key: "tags",
            option: [],
          },
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
        actions: [
          /*{
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-deal-modal",
            modalId: "deal-modal",
            url: "",
            modifier: () => this.$can("update_deals"),
          },*/
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "deal-delete-modal",
            url: "",
            modifier: () => this.$can("delete_deals"),
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      pipelineTicketTypeList: "getListPipelineTicketType",
    }),
    souvenirPipeline() {

      return this.pipelineTicketTypeList.find(item => item.ticket_type == 5);

    },

    hasSouvenirPipeline() {

      return !!this.souvenirPipeline;

    },
    visiblePipelineTicketTypeList() {

      return this.pipelineTicketTypeList.filter(item => item.ticket_type != 5);

    },
  },
  methods: {


    openModalSet(value) {
      if (value == 1) {
        this.MoreTitle = this.$t("visit");
      } else if (value == 2) {
        this.MoreTitle = this.$t("gidens");
      } else if (value == 3) {
        this.MoreTitle = this.$t("lectures");
      } else if (value == 4) {
        this.MoreTitle = this.$t("event");
      }



      const pipeline = this.pipelineTicketTypeList.find(
        item => item.ticket_type == value
      );

      this.selectedPipeline = pipeline?.id || null;
      this.selectedPipelineType = value;
      this.selectedPipelineName = pipeline?.name || null;

      let instance = this;
      instance.isDealModalActive = true;
      setTimeout(function () {
        $("#deal-modal").modal("show");
      });




    },


    filteredValues(value) {
      if (value["pipeline"]) {
        this.selectedPipeline = value.pipeline;
        this.localPipelineId = value.pipeline;
        this.currentPipeline = this.options.filters
          .find((el) => el.title === this.$t("pipelines"))
          .option.find((el) => el.id === this.localPipelineId).value;
      } else {
        this.currentPipeline = this.$t("All pipelines");
      }

      if (value["pipeline"] == 0) {
        this.selectedPipeline = 1;
      }
    },
    getDealValue() {
      this.axiosGet("crm/deal-value").then((response) => {
        this.options.filters.push({
          title: this.$t("deal_value"),
          type: "range-filter",
          key: "deal-value",
          minTitle: this.$t("minimum_value"),
          maxTitle: this.$t("maximum_value"),
          maxRange: response.data.max_deal_value,
          minRange:
            response.data.min_deal_value < response.data.max_deal_value
              ? response.data.min_deal_value
              : 0,
        });
      });
    },
    getAllPipeline() {
      this.axiosGet("crm/pipelinesbymuseum").then((response) => {
        this.pipelineValue = response.data.data;
        this.isPipelineEmpty = this.pipelineValue.length > 0 ? false : true;
        this.pipelineInitValue = 0;
        this.options.filters.unshift({
          title: this.$t("pipelines"),
          type: "dropdown-menu-filter",
          key: "pipeline",
          initValue: this.pipelineInitValue,
          option: ([] = response.data.data.map((pipelines) => {
            return {
              id: pipelines.id,
              value: pipelines.name,
            };
          })),
        });
        if (this.isPipelineEmpty) {
          let pipeline = this.options.filters.find(
            (elsement) => elsement.title === this.$t("pipelines")
          );
          pipeline.option = [
            {
              id: 0,
              value: this.$t("Select a pipeline"),
            },
          ];
        } else {
          let pipeline = this.options.filters.find(
            (elsement) => elsement.title === this.$t("pipelines")
          );
          pipeline.option.unshift({
            id: 0,
            value: this.$t("All pipeline"),
          });
        }
      });
    },
    getAction(rowData, actionObj, active) {
      let instance = this;
      if (actionObj.title == this.$t("edit")) {
        instance.selectedUrl = `crm/deals/${rowData.id}`;
        instance.isDealModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        instance.deal = rowData.id;
        instance.confirmationModalActive = true;
      }
    },
    confirmed() {
      let instance = this,
        url = `crm/deals/${this.deal}`;
      this.axiosDelete(url)
        .then((response) => {
          instance.$toastr.s(response.data.message);
          instance.$hub.$emit("reload-" + this.tableId);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          instance.cancelled();
        });
    },
    cancelled() {
      let instance = this;
      instance.confirmationModalActive = false;
    },





    openModalSuv(pipelineId) {
      this.isWarehouseModalActive = true;
      this.selectedPipeline = pipelineId;
    },






    openModal() {
      let instance = this;
      instance.isDealModalActive = true;
      setTimeout(function () {
        $("#deal-modal").modal("show");
      });
    },
    closeModal() {
      this.selectedPipelineType = "";
      let instance = this;
      this.isDealModalActive = false;
      this.isWarehouseModalActive = false;
      $("#warehouse-modal").modal("hide");
      instance.selectedUrl = "";
      $("#deal-modal").modal("hide");
    },
    openLostreasonModal() {
      this.isModalActive = true;
      $("#lost-reason-modal").modal("show");
    },
    closeLostReasonModal() {
      this.isModalActive = false;
      this.selectedUrlReason = "";
      $("#lost-reason-modal").modal("hide");
    },
  },
  mounted() {
    setTimeout(() => {
      // this.$store.dispatch("getOwner"),
      //this.$store.dispatch("getOrganization"), this.$store.dispatch("getPerson"), this.$store.dispatch("getPersongid");
      this.$store.dispatch("getPersongid");
      this.getDealValue();
    }, 1000);

    $("#deal-modal").on("hidden.bs.modal", () => {
      this.isDealModalActive = false;
    });

    $("#deal-delete-modal").on("hidden.bs.modal", () => {
      this.confirmationModalActive = false;
    });

    this.getCustomFiled("deal");
    this.$store.dispatch("getListPipelineTicketType");
  },
  created() {
    // this.getDealValue();
    // this.getAllPipeline();
  },
};
</script>
